module.exports = __webpack_public_path__ + "img/wolf-lightMode.898d8aa7.svg";